import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Paper as MuiPaper,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch } from "react-redux";

import Delete from "../../../../components/Delete";
import usePlanGroup from "../../../../hooks/usePlanGroup";
import DeletePlanGroupModal from "./DeletePlanGroupModal";
import { useDialog } from "../../../../contexts/DialogContext";
import { getTimeStamp } from "../../../../utils/common";
import EditDelete from "../../../../components/EditDelete";
import MapPlanModal from "./MapPlanModal";
import { useFormContext } from "react-hook-form";

const Paper = styled(MuiPaper)(spacing);

const MappedPlan = ({ planGroupId, isSharingAllowed, sharingType, planGroupPlans }) => {
  const { openDialog } = useDialog();
  const currentPayload = {
    filters: [
      {
        fieldName: "planGroupId",
        fieldValue: planGroupId,
        op: "eq",
        isJoin: true,
        dataType: "long",
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [],
  };
  const {
    formState: { errors },
    watch,
  } = useFormContext();

  const [payload, setPayload] = useState(currentPayload);

  const msoSharing = watch("msoSharing");
  const distSharing = watch("distSharing");
  const lcoSharing = watch("lcoSharing");
  const ottMsoSharing = watch("ottMsoSharing");
  const ottDistSharing = watch("ottDistSharing");
  const ottLcoSharing = watch("ottLcoSharing");

  const msoSharingName = msoSharing + "%";
  const distSharingName = distSharing + "%";
  const lcoSharingName = lcoSharing + "%";
  const ottMsoSharingName = ottMsoSharing + "%";
  const ottDistSharingName = ottDistSharing + "%";
  const ottLcoSharingName = ottLcoSharing + "%";

  // const fetchData = async () => {
  //   const planGroupValues = await getPlanGroupPlans(payload);
  //   if (sharingType == "FIXED") {
  //     const updatedPlans = planGroupValues.data.map((plan) => ({
  //       ...plan, // keep existing planId or other fields
  //       msoSharing,
  //       distSharing,
  //       lcoSharing,
  //       ottMsoSharing,
  //       ottDistSharing,
  //       ottLcoSharing,
  //       msoSharingName,
  //       distSharingName,
  //       lcoSharingName,
  //       ottMsoSharingName,
  //       ottDistSharingName,
  //       ottLcoSharingName,
  //     }));
  //     setPlanGroupPlan(updatedPlans);
  //   }
  // };

  const deleteItemClick = async (planSharingId) => {
    return openDialog(
      "delete_plan_group",
      "Delete Plan Group",
      <DeletePlanGroupModal
        key={getTimeStamp()}
        planSharingId={planSharingId}
        refreshPage={fetchData}
      />,
    );
  };

  const editPage = async (planSharingId, actionType) => {
    return openDialog(
      "map_plan_modal",
      "Edit Sharing",
      <MapPlanModal
        planGroupId={planGroupId}
        planGroupPlanId={planSharingId}
        key={getTimeStamp()}
        isNew={true}
        isSharingAllowed={isSharingAllowed}
        isEditable={true}
        actionName="Update"
      />,
    );
  };

  // useEffect(() => {
  //   fetchData();
  // }, [payload]);

  const columns = [
    {
      field: "action",
      headerName: "Action",
      filter: false,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          const api = params.api;
          const thisRow = {};
          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach((c) => (thisRow[c.field] = params.getValue(params.id, c.field)));
          console.log(thisRow, "thisRow");
        };
        return (
          <EditDelete
            menus={sharingType == "FIXED" ? ["delete"] : ["delete", "edit"]}
            rowClick={onClick}
            deleteItemClick={() => deleteItemClick(params.id)}
            editPage={() => editPage(params.id)}
          />
        );
      },
    },
    {
      field: "plan",
      headerName: "Plan Name",
      valueGetter: (params) => params.planName,
      type: "string",
      width: 300,
    },
    {
      field: "msoSharingName",
      headerName: "MSO Sharing",
      width: 100,
    },
    {
      field: "distSharingName",
      headerName: "Dist Sharing",
      width: 100,
    },
    {
      field: "lcoSharingName",
      headerName: "LCO Sharing",
      width: 100,
    },

    {
      field: "ottMsoSharingName",
      headerName: "OTT MSO Sharing",
      width: 100,
    },
    {
      field: "ottDistSharingName",
      headerName: "OTT Dist Sharing",
      width: 100,
    },
    {
      field: "ottLcoSharingName",
      headerName: "OTT LCO Sharing",
      width: 100,
    },
  ];
  const onPageChange = (page) => {
    console.log(page, "pagepage");
    const pagination = {
      pageNumber: page == 0 ? 1 : page + 1,
      pageSize: payload.pagination.pageSize,
    };
    setPayload((prev) => ({ ...prev, pagination }));
  };
  return (
    <Card mb={6}>
      <Paper>
        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            columns={columns}
            rows={planGroupPlans}
            rowCount={planGroupPlans.length}
            getRowId={(row) => row["planGroupPlanId"]}
            loading={isLoading}
            rowsPerPageOptions={[5]}
            pagination
            page={1}
            pageSize={paging.pageSize}
            paginationMode="server"
            onPageChange={(page) => onPageChange(page)}
            onPageSizeChange={(pageSize) => onPageChange(pageSize)}
            checkboxSelection
            sortingMode="server"
            //sortModel={sortModel}
            //onSortModelChange={handleSortModelChange}
          />
        </div>
      </Paper>
    </Card>
  );
};

export default MappedPlan;
